import { supabase } from '@/lib/supabase';

export const uploadBackgroundImage = async (file: File, userId: string): Promise<string | null> => {
  try {
    // Create a unique file name using userId and timestamp
    const fileExt = file.name.split('.').pop();
    const fileName = `${userId}-${Date.now()}.${fileExt}`;
    const filePath = `backgrounds/${fileName}`;

    // Upload the file to Supabase storage
    const { error: uploadError } = await supabase.storage
      .from('backgrounds')
      .upload(filePath, file);

    if (uploadError) {
      console.error('Error uploading image:', uploadError);
      return null;
    }

    // Get the public URL for the uploaded file
    const { data: { publicUrl } } = supabase.storage
      .from('backgrounds')
      .getPublicUrl(filePath);

    return publicUrl;
  } catch (error) {
    console.error('Error in uploadBackgroundImage:', error);
    return null;
  }
};

export const deleteBackgroundImage = async (imageUrl: string): Promise<boolean> => {
  try {
    // Extract the file path from the URL
    const filePath = imageUrl.split('/').pop();
    if (!filePath) return false;

    // Delete the file from Supabase storage
    const { error } = await supabase.storage
      .from('backgrounds')
      .remove([`backgrounds/${filePath}`]);

    if (error) {
      console.error('Error deleting image:', error);
      return false;
    }

    return true;
  } catch (error) {
    console.error('Error in deleteBackgroundImage:', error);
    return false;
  }
}; 